<template>
  <div class="container d-flex py-5 main-container">
    <div class="my-auto w-100 main-area login-area">
      <div class="row">
        <div class="col-md-12">
          <div class="login-dtl">
            <h2>パスワードの再設定</h2>
            <div class="login-form">
              <form @submit.prevent="reset">
                <div class="custom-form-block">
                  <div class="form-group row">
                    <div class="col-md-12 mb-30">
                      <label>メールアドレス</label>
                      <div class="input-group custom-group">
                        <input
                          type="text"
                          class="form-control is-valid"
                          v-bind:class="{ 'is-invalid': hasError('email') }"
                          name="email"
                          v-model="email"
                          v-validate="'required|email'"
                          autocomplete="username"
                          data-vv-as="メールアドレス"
                        />
                        <!-- <i class="front-icon fa fa-envelope" aria-hidden="true"></i> -->
                        <div class="invalid-feedback" v-if="hasError('email')">
                           {{ getErrorMessage("email") }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 mb-2">
                      <label>パスワード（8文字以上設定してください）</label>
                      <div class="input-group custom-group">
                        <input
                          type="password"
                          class="form-control is-valid"
                          v-bind:class="{ 'is-invalid': hasError('password') }"
                          name="password"
                          v-model="password"
                          v-validate="'required|doubleByte|min:8'"
                          ref="password"
                          autocomplete="new-password"
                          data-vv-as="パスワード"
                        />
                        <!-- <i class="front-icon fa fa-lock" aria-hidden="true"></i> -->
                        <div
                          class="invalid-feedback"
                          v-if="hasError('password')"
                        >
                           {{ getErrorMessage("password") }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 mb-2">
                      <label>パスワード（確認用）</label>
                      <div class="input-group custom-group">
                        <input
                          type="password"
                          class="form-control is-valid"
                          v-bind:class="{
                            'is-invalid': hasError('password_confirmation'),
                          }"
                          name="password_confirmation"
                          v-model="password_confirmation"
                          v-validate="'required|confirmed:password'"
                          data-vv-as="パスワード"
                        />
                        <!-- <i class="front-icon fa fa-lock" aria-hidden="true"></i> -->
                        <div
                          class="invalid-feedback"
                          v-if="hasError('password_confirmation')"
                        >
                           
                          {{ getErrorMessage("password_confirmation") }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mb-30"></div>
                  <div
                    class="btn-toolbar"
                    role="toolbar"
                    aria-label="Toolbar with button groups"
                  >
                    <router-link
                      to="/login"
                      class="btn btn-cstm btn-cstm-second btn-cstm-primary"
                      style="margin-right:50px;"
                      >キャンセル</router-link
                    >
                    <button
                      type="submit"
                      class="btn btn-cstm btn-cstm-third btn-cstm-primary"
                    >
                      変更を保存
                    </button>
                  </div>
                </div>
                <!-- ends custom-form-block -->
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ends main-area -->
  </div>
</template>
<script>
import swal from "sweetalert";
import Api from "@/config/api";
import logo from "../assets/Group300.png";

export default {
  data() {
    return {
      token: this.$route.params.token,
      email: "",
      password: "",
      password_confirmation: "",
      server_errors: {},
    };
  },
  methods: {
    hasError(field) {
      return field in this.server_errors || this.errors.first(field);
    },
    getErrorMessage(field) {
      if (this.errors.first(field)) return this.errors.first(field);
      if (field in this.server_errors) return this.server_errors[field].msg;
      return null;
    },
    async reset() {
      try {
        if (!this.token ) {
          this.$router.push({ name: "pageNotFound" });
        } else {
          const check = await this.$validator.validate();
          if (check) {
            await this.axios({
              method: "post",
              data: {
                token: this.token,
                email: this.email,
                password: this.password,
                password_confirmation: this.password_confirmation,
              },
              url: Api.url(Api.endpoints.forgotPassword),
            });
            await swal({
              title: "パスワードを変更しました。",
              text: "",
              icon: logo,
              className: "custom-swal4",
              buttons: {
                ok: "OK",
              },
            });
            this.$router.push({ name: "login" });
          }
        }
      } catch (error) {
        if (error.response.status === 422) {
          this.server_errors = error.response.data;
        } else {
          await swal({
            text: error.response.data.message,
            icon: "warning",
          });
          this.$router.push({ name: "login" });
        }
      }
    },
  },
};
</script>
<style scoped>
.btn-toolbar {
  display: flex;
  justify-content: flex-start;
}

.btn-cstm {
  width: 200px;
  font-size: 12px;
  border-radius: 4px;
}

.btn-cstm-second {
  background: #787878;
  border: #787878;
}

.btn-cstm-third {
  background: #2167a8;
  border: #2167a8;
}

.is-valid {
  background-image: none;
}

.is-invalid {
  background-image: none;
}

h2 {
  color: #000;
  /* text-align: center; */
}
label {
  color: #000;
}

@media (max-width: 768px) {
  .btn-toolbar {
    flex-wrap: wrap;
  }

  .btn-cstm {
    width: 47%; /* Modify the width as per your requirement */
    margin-bottom: 2px; /* Add spacing between the buttons */
  }

  .btn-cstm-second {
    margin-right: 10px !important; /* Remove right margin for the first button */
  }
}
</style>
